import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CookieConsent from "react-cookie-consent";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Booking from "./components/Booking";
import Footer from "./components/Footer";
import Admin from "./pages/Admin";
import Impressum from "./pages/Impressum";
import Datenschutz from "./pages/Datenschutz";
import { Toaster } from "./components/ui/sonner";

const Home = () => {
  return (
    <div>
      <Header />
      <Hero />
      <About />
      <Services />
      <Testimonials />
      <Contact />
      <Booking />
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
      
      {/* DSGVO Cookie Banner */}
      <CookieConsent
        location="bottom"
        buttonText="Alle akzeptieren"
        declineButtonText="Nur notwendige"
        enableDeclineButton
        cookieName="wahr-cookie-consent"
        style={{
          background: "#2C5F7C",
          padding: "20px",
          alignItems: "center",
        }}
        buttonStyle={{
          background: "#87CEEB",
          color: "#fff",
          fontSize: "14px",
          padding: "10px 24px",
          borderRadius: "6px",
          fontWeight: "500",
        }}
        declineButtonStyle={{
          background: "#A8A8A8",
          color: "#fff",
          fontSize: "14px",
          padding: "10px 24px",
          borderRadius: "6px",
          fontWeight: "500",
        }}
        expires={365}
      >
        <span style={{ fontSize: "14px", lineHeight: "1.6" }}>
          Diese Website verwendet Cookies, um Ihnen die bestmögliche Nutzererfahrung zu bieten. 
          Durch die weitere Nutzung der Website stimmen Sie der Verwendung von Cookies zu.{" "}
          <a
            href="/datenschutz"
            style={{ color: "#87CEEB", textDecoration: "underline" }}
          >
            Mehr erfahren
          </a>
        </span>
      </CookieConsent>
    </div>
  );
}

export default App;
